// extracted by mini-css-extract-plugin
module.exports = {"totalCount":"staleRecordsCard_totalCount__dmhhA"};